"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isAlways: () => isAlways,
  isAnd: () => isAnd,
  isCanGrantQualification: () => isCanGrantQualification,
  isCanGrantRole: () => isCanGrantRole,
  isGlobalRoleName: () => isGlobalRoleName,
  isHasAccount: () => isHasAccount,
  isHasQualification: () => isHasQualification,
  isHasRole: () => isHasRole,
  isHasUserId: () => isHasUserId,
  isInAnyWorkspace: () => isInAnyWorkspace,
  isNamed: () => isNamed,
  isNever: () => isNever,
  isOr: () => isOr,
  isPermissionCheck: () => isPermissionCheck,
  isProjectRoleName: () => isProjectRoleName,
  isQualificationRole: () => isQualificationRole,
  isQualificationRoleName: () => isQualificationRoleName,
  isRole: () => isRole,
  isTeamRoleName: () => isTeamRoleName,
  isWorkspaceAccess: () => isWorkspaceAccess,
  isWorkspaceRoleName: () => isWorkspaceRoleName
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_util = require("@cartographerio/util");
const isRole = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "Role")(v);
};
const isQualificationRole = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "QualificationRole")(v);
};
const isGlobalRoleName = (v) => {
  return v === "MapViewer" || v === "Admin" || v === "Superuser";
};
const isWorkspaceRoleName = (v) => {
  return v === "Disabled" || v === "Active" || v === "Admin" || v === "Owner";
};
const isProjectRoleName = (v) => {
  return v === "Member" || v === "Surveyor" || v === "Approver" || v === "Coordinator";
};
const isTeamRoleName = (v) => {
  return v === "Member" || v === "Surveyor" || v === "Approver" || v === "Coordinator";
};
const isQualificationRoleName = (v) => {
  return v === "Expired" || v === "Trainee" || v === "Qualified" || v === "Trainer" || v === "Coordinator";
};
const isAlways = (v) => {
  return typeof v === "object" && v != null;
};
const isNever = (v) => {
  return typeof v === "object" && v != null && (!("reason" in v) || typeof v.reason === "string" || v.reason === null);
};
const isAnd = (v) => {
  return typeof v === "object" && v != null && "args" in v && Array.isArray(v.args) && v.args.every((i) => isPermissionCheck(i));
};
const isOr = (v) => {
  return typeof v === "object" && v != null && "args" in v && Array.isArray(v.args) && v.args.every((i) => isPermissionCheck(i));
};
const isHasRole = (v) => {
  return typeof v === "object" && v != null && "role" in v && isRole(v.role);
};
const isCanGrantRole = (v) => {
  return typeof v === "object" && v != null && "role" in v && isRole(v.role);
};
const isHasQualification = (v) => {
  return typeof v === "object" && v != null && "role" in v && isQualificationRole(v.role);
};
const isCanGrantQualification = (v) => {
  return typeof v === "object" && v != null && "role" in v && isQualificationRole(v.role);
};
const isHasAccount = (v) => {
  return typeof v === "object" && v != null;
};
const isHasUserId = (v) => {
  return typeof v === "object" && v != null && "userId" in v && (0, import_types_generated.isUserId)(v.userId);
};
const isInAnyWorkspace = (v) => {
  return typeof v === "object" && v != null && "name" in v && isWorkspaceRoleName(v.name);
};
const isNamed = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "check" in v && isPermissionCheck(v.check);
};
const isWorkspaceAccess = (v) => {
  return typeof v === "object" && v != null && "workspaceId" in v && (0, import_types_generated.isWorkspaceId)(v.workspaceId) && "minAccess" in v && (0, import_types_generated.isWorkspaceAccessLevel)(v.minAccess);
};
const isPermissionCheck = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "Always" && isAlways(v) || v.type === "And" && isAnd(v) || v.type === "CanGrantQualification" && isCanGrantQualification(v) || v.type === "CanGrantRole" && isCanGrantRole(v) || v.type === "HasAccount" && isHasAccount(v) || v.type === "HasQualification" && isHasQualification(v) || v.type === "HasRole" && isHasRole(v) || v.type === "HasUserId" && isHasUserId(v) || v.type === "InAnyWorkspace" && isInAnyWorkspace(v) || v.type === "Named" && isNamed(v) || v.type === "Never" && isNever(v) || v.type === "Or" && isOr(v) || v.type === "WorkspaceAccess" && isWorkspaceAccess(v));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAlways,
  isAnd,
  isCanGrantQualification,
  isCanGrantRole,
  isGlobalRoleName,
  isHasAccount,
  isHasQualification,
  isHasRole,
  isHasUserId,
  isInAnyWorkspace,
  isNamed,
  isNever,
  isOr,
  isPermissionCheck,
  isProjectRoleName,
  isQualificationRole,
  isQualificationRoleName,
  isRole,
  isTeamRoleName,
  isWorkspaceAccess,
  isWorkspaceRoleName
});
//# sourceMappingURL=types.generated.js.map
